// ?taps in the address the app opens with: every press shows as a soft white disc that follows the finger and grows
// and fades out on release, as touches look on a phone screen recording (for demo recordings).
const SHOW = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('taps');

export const showTaps = () => {
  if (!SHOW) return;
  let dot = null;
  const place = event => {
    dot.style.left = `${event.clientX}px`;
    dot.style.top = `${event.clientY}px`;
  };
  window.addEventListener('pointerdown', event => {
    dot = document.createElement('div');
    dot.className = 'tap-dot';
    place(event);
    document.body.appendChild(dot);
    const shown = dot;
    requestAnimationFrame(() => shown.classList.add('down'));
  }, true);
  window.addEventListener('pointermove', event => dot && place(event), true);
  const release = () => {
    if (!dot) return;
    const done = dot;
    dot = null;
    done.classList.remove('down');
    done.classList.add('up');
    setTimeout(() => done.remove(), 450);
  };
  window.addEventListener('pointerup', release, true);
  window.addEventListener('pointercancel', release, true);
};
